import { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

export const CookieBanner: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-4 bg-black/90 backdrop-blur-md border-t border-primary-green/30">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm text-gray-300">
            We use cookies to enhance your experience and analyze site traffic. By continuing to use this site, you consent to our use of cookies.{' '}
            <a href="/policies/cookies" className="text-primary-green hover:underline">
              Learn more
            </a>
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleAccept}
            className="btn-primary text-sm py-2 px-4"
          >
            Accept All
          </button>
          <button
            onClick={handleAccept}
            className="btn-secondary text-sm py-2 px-4"
          >
            <FiX className="inline mr-1" />
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

